module.exports = __webpack_public_path__ + "img/as3.440996f8.jpg";